module.exports = __webpack_public_path__ + "img/faq.774aeee0.png";